(function () {
  'use strict';
  if (window.cerusModelViewer) return;

  var instances = new WeakMap();
  var initQueue = [];

  function waitForBabylon(cb) {
    if (window.BABYLON && window.BABYLON.SceneLoader) { cb(); return; }
    setTimeout(function () { waitForBabylon(cb); }, 100);
  }

  function buildInstance(viewer) {
    var BAB = window.BABYLON;
    var canvas = viewer.querySelector('canvas.cerus-3d-viewer__canvas');
    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.className = 'cerus-3d-viewer__canvas';
      canvas.setAttribute('touch-action', 'none');
      viewer.insertBefore(canvas, viewer.firstChild);
    }
    var engine = new BAB.Engine(canvas, true, {
      preserveDrawingBuffer: true,
      stencil: true,
      antialias: true,

      adaptToDeviceRatio: true,
      powerPreference: 'high-performance'
    });

    var dpr = Math.max(1, Math.min(window.devicePixelRatio || 1, 3));
    engine.setHardwareScalingLevel(1 / dpr);
    var scene = new BAB.Scene(engine);
    scene.clearColor = new BAB.Color4(0, 0, 0, 0);
    scene.useRightHandedSystem = true;

    var camera = new BAB.ArcRotateCamera(
      'cerusCam',
      BAB.Tools.ToRadians(-25),
      BAB.Tools.ToRadians(100),
      12,
      new BAB.Vector3(0, 1, 0),
      scene
    );
    camera.inputs.clear();
    camera.panningSensibility = 0;
    camera.lowerRadiusLimit = 0.01;
    camera.upperRadiusLimit = 1000;
    camera.lowerAlphaLimit = camera.alpha;
    camera.upperAlphaLimit = camera.alpha;
    camera.lowerBetaLimit = camera.beta;
    camera.upperBetaLimit = camera.beta;
    camera.fov = BAB.Tools.ToRadians(20);
    camera.minZ = 0.01;
    camera.maxZ = 5000;

    function sizeEngine() {
      var w = viewer.clientWidth || canvas.clientWidth || 400;
      var s = Math.min(w, 1400);
      if (s < 400) s = 400;
      engine.setSize(s, s);
      var dpr = Math.max(1, Math.min(window.devicePixelRatio || 1, 3));
      engine.setHardwareScalingLevel(1 / dpr);
    }
    sizeEngine();
    window.addEventListener('resize', sizeEngine);
    if (window.ResizeObserver) new ResizeObserver(sizeEngine).observe(viewer);

    var env = BAB.CubeTexture.CreateFromPrefilteredData('https://assets.babylonjs.com/environments/environmentSpecular.env', scene);
    env.rotationY = BAB.Tools.ToRadians(90);
    scene.environmentTexture = env;
    scene.environmentIntensity = 1.4;
    scene.imageProcessingConfiguration.exposure = 1.45;
    scene.imageProcessingConfiguration.contrast = 1.05;
    scene.imageProcessingConfiguration.toneMappingEnabled = true;
    scene.imageProcessingConfiguration.toneMappingType = BAB.ImageProcessingConfiguration.TONEMAPPING_ACES;

    new BAB.DirectionalLight('key', new BAB.Vector3(-0.3, -0.9, -0.5), scene).intensity = 1.6;
    new BAB.DirectionalLight('fill', new BAB.Vector3(0.6, -0.4, 0.7), scene).intensity = 0.65;
    new BAB.DirectionalLight('rim', new BAB.Vector3(0.2, 0.3, -0.9), scene).intensity = 0.5;
    new BAB.HemisphericLight('hemi', new BAB.Vector3(0, 1, 0), scene).intensity = 0.55;

    var tiltContainer = new BAB.TransformNode('tilt', scene);
    var liftContainer = new BAB.TransformNode('lift', scene);
    var spinContainer = new BAB.TransformNode('spin', scene);
    liftContainer.parent = tiltContainer;
    spinContainer.parent = liftContainer;
    tiltContainer.rotation.x = BAB.Tools.ToRadians(3);
    tiltContainer.rotation.z = BAB.Tools.ToRadians(4);

    engine.runRenderLoop(function () { scene.render(); });
    return {
      engine: engine, scene: scene, camera: camera,
      tilt: tiltContainer, lift: liftContainer, spin: spinContainer,
      importRoot: null, assetContainer: null, currentUrl: null,
      spinObserver: null, loadingToken: 0,
      sizeEngine: sizeEngine,
      viewer: viewer
    };
  }

  function dispose(inst) {
    var BAB = window.BABYLON;
    if (inst.spinObserver) { inst.scene.onBeforeRenderObservable.remove(inst.spinObserver); inst.spinObserver = null; }
    if (inst.assetContainer) { inst.assetContainer.removeAllFromScene(); inst.assetContainer.dispose(); inst.assetContainer = null; }
    if (inst.importRoot) { inst.importRoot.dispose(); inst.importRoot = null; }
    inst.tilt.position.set(0, 0, 0);
    inst.tilt.rotation.set(BAB.Tools.ToRadians(3), 0, BAB.Tools.ToRadians(4));
    inst.tilt.scaling.set(1, 1, 1);
    inst.lift.position.set(0, 0, 0);
    inst.lift.rotation.set(0, 0, 0);
    inst.lift.scaling.set(1, 1, 1);
    inst.spin.position.set(0, 0, 0);
    inst.spin.rotation.set(0, 0, 0);
    inst.spin.scaling.set(1, 1, 1);
  }

  function frame(inst, root) {
    var BAB = window.BABYLON;

    inst.tilt.position.set(0, 0, 0);
    inst.tilt.rotation.set(0, 0, 0);
    inst.tilt.scaling.set(1, 1, 1);
    inst.lift.position.set(0, 0, 0);
    inst.lift.rotation.set(0, 0, 0);
    inst.lift.scaling.set(1, 1, 1);
    inst.spin.position.set(0, 0, 0);
    inst.spin.rotation.set(0, 0, 0);
    inst.spin.scaling.set(1, 1, 1);
    root.position.set(0, 0, 0);
    root.rotation.set(0, 0, 0);
    root.scaling.set(1, 1, 1);

    var meshes = root.getChildMeshes(false);
    meshes.forEach(function (m) {
      m.scaling.x = Math.abs(m.scaling.x);
      m.scaling.y = Math.abs(m.scaling.y);
      m.scaling.z = Math.abs(m.scaling.z);
    });

    function forceWorld(node) {
      if (node.computeWorldMatrix) node.computeWorldMatrix(true);
      var children = node.getChildren();
      for (var i = 0; i < children.length; i++) forceWorld(children[i]);
    }
    inst.scene.incrementRenderId();
    forceWorld(inst.tilt);
    meshes.forEach(function (m) {
      if (m.refreshBoundingInfo) {
        try { m.refreshBoundingInfo(true); } catch (e) {
          try { m.refreshBoundingInfo(); } catch (e2) {}
        }
      }
    });

    var min = new BAB.Vector3(Infinity, Infinity, Infinity);
    var max = new BAB.Vector3(-Infinity, -Infinity, -Infinity);
    var counted = 0;
    meshes.forEach(function (m) {
      if (!m.getBoundingInfo) return;
      var bi = m.getBoundingInfo();
      if (!bi || !bi.boundingBox) return;
      var lo = bi.boundingBox.minimumWorld;
      var hi = bi.boundingBox.maximumWorld;
      if (!lo || !hi) return;
      if (!isFinite(lo.x) || !isFinite(lo.y) || !isFinite(lo.z)) return;
      if (!isFinite(hi.x) || !isFinite(hi.y) || !isFinite(hi.z)) return;
      var dx = Math.abs(hi.x - lo.x);
      var dy = Math.abs(hi.y - lo.y);
      var dz = Math.abs(hi.z - lo.z);
      if (dx + dy + dz < 1e-6) return;
      min.minimizeInPlace(lo);
      max.maximizeInPlace(hi);
      counted++;
    });

    if (counted === 0 || !isFinite(min.x) || !isFinite(max.x)) {
      if (window.console && console.warn) console.warn('[Cerus3D] no measurable meshes', { count: meshes.length });
      return;
    }

    var size = max.subtract(min);
    var center = BAB.Vector3.Center(min, max);

    if (window.console && console.log) {
      console.log('[Cerus3D] frame', {
        meshes: meshes.length, counted: counted,
        min: [min.x.toFixed(2), min.y.toFixed(2), min.z.toFixed(2)].join(','),
        max: [max.x.toFixed(2), max.y.toFixed(2), max.z.toFixed(2)].join(','),
        center: [center.x.toFixed(2), center.y.toFixed(2), center.z.toFixed(2)].join(','),
        size: [size.x.toFixed(2), size.y.toFixed(2), size.z.toFixed(2)].join(',')
      });
    }

    var children = root.getChildren(undefined, true);
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (c.position) {
        c.position.x -= center.x;
        c.position.y -= center.y;
        c.position.z -= center.z;
      }
    }

    var schemaTarget = parseFloat(inst.viewer && inst.viewer.getAttribute('data-cerus-3d-target'));
    var targetMax = isFinite(schemaTarget) && schemaTarget > 0 ? schemaTarget : 6;
    var maxDim = Math.max(size.x, size.y, size.z);
    var s = maxDim > 0 ? (targetMax / maxDim) : 1;
    inst.lift.scaling.set(s, s, s);

    var heightWorld = size.y * s;
    var widthWorld = Math.max(size.x, size.z) * s;
    var fitDim = Math.max(heightWorld, widthWorld);
    var schemaZoom = parseFloat(inst.viewer && inst.viewer.getAttribute('data-cerus-3d-zoom'));
    var verticalPad = isFinite(schemaZoom) && schemaZoom > 0 ? schemaZoom : 1.5;
    var needed = ((fitDim * verticalPad) / 2) / Math.tan(inst.camera.fov / 2);
    inst.camera.radius = needed;
    inst.camera.lowerRadiusLimit = needed;
    inst.camera.upperRadiusLimit = needed;
    inst.camera.target = BAB.Vector3.Zero();

    inst.camera.minZ = Math.max(0.1, needed * 0.25);
    inst.camera.maxZ = needed * 4;

    function isLabelMaterial(matName) {
      var n = (matName || '').toLowerCase();
      return n.indexOf('plastic 4') !== -1 ||
             n.indexOf('label') !== -1 ||
             n.indexOf('paper') !== -1 ||
             /^material\d+$/i.test(matName || '');
    }
    function isLabelMesh(meshName) {
      var n = (meshName || '').toLowerCase();
      return n.indexOf('cylinder') !== -1 || n.indexOf('label') !== -1;
    }

    if (inst.assetContainer && inst.assetContainer.materials) {
      inst.assetContainer.materials.forEach(function (mat) {
        if (!mat) return;
        var labelLike = isLabelMaterial(mat.name);
        if (typeof mat.zOffset === 'number') mat.zOffset = labelLike ? -8 : -2;
        if (typeof mat.zOffsetUnits === 'number') mat.zOffsetUnits = labelLike ? -8 : -2;
      });
    }


    var hideList = (inst.viewer && inst.viewer.getAttribute('data-cerus-3d-hide') || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);

    if (window.console && console.log) {
      console.log('[Cerus3D] hideList =', hideList);
      meshes.forEach(function (m, i) {
        if (!m || !m.getBoundingInfo) return;
        var bi = m.getBoundingInfo();
        if (!bi || !bi.boundingBox) return;
        var lo = bi.boundingBox.minimumWorld;
        var hi = bi.boundingBox.maximumWorld;
        var dx = hi.x - lo.x, dy = hi.y - lo.y, dz = hi.z - lo.z;
        var matName = m.material && m.material.name ? m.material.name : '(none)';
        console.log('[Cerus3D] mesh[' + i + '] name="' + m.name + '" material="' + matName + '" size=' + dx.toFixed(2) + ',' + dy.toFixed(2) + ',' + dz.toFixed(2) + ' visible=' + (m.isVisible !== false));
      });
    }

    if (hideList.length) {
      meshes.forEach(function (m) {
        if (!m || !m.name) return;
        var nameLc = m.name.toLowerCase();
        var matNameLc = (m.material && m.material.name) ? m.material.name.toLowerCase() : '';
        for (var i = 0; i < hideList.length; i++) {
          var needle = hideList[i];
          if (!needle) continue;
          if (nameLc.indexOf(needle) !== -1 || matNameLc.indexOf(needle) !== -1) {
            m.isVisible = false;
            m.setEnabled(false);
            break;
          }
        }
      });
    }

    inst.tilt.rotation.set(BAB.Tools.ToRadians(-2), 0, BAB.Tools.ToRadians(4));

    inst.scene.incrementRenderId();
    forceWorld(inst.tilt);
  }

  function loadGLB(viewer, inst, url) {
    var BAB = window.BABYLON;
    var loader = viewer.querySelector('.cerus-3d-viewer__loader');
    var hint = viewer.querySelector('.cerus-3d-viewer__hint');
    if (url && url.toLowerCase().split('?')[0].slice(-4) !== '.glb') url = '';
    if (!url) {
      dispose(inst);
      if (loader) { loader.style.display = 'flex'; loader.innerHTML = '<span>No model available for this variant</span>'; }
      if (hint) hint.style.display = 'none';
      return;
    }
    if (url === inst.currentUrl) return;
    inst.currentUrl = url;
    if (loader) { loader.style.display = 'flex'; loader.innerHTML = '<i class="fa-solid fa-circle-notch fa-spin" aria-hidden="true"></i>'; }
    if (hint) hint.style.display = '';
    dispose(inst);
    var token = ++inst.loadingToken;

    var parts = url.split('/');
    var file = parts.pop();
    var rootUrl = parts.join('/') + '/';

    BAB.SceneLoader.LoadAssetContainer(rootUrl, file, inst.scene, function (container) {
      if (token !== inst.loadingToken) { container.dispose(); if (loader) loader.style.display = 'none'; return; }
      inst.assetContainer = container;
      container.addAllToScene();
      if (container.animationGroups && container.animationGroups.length) {
        container.animationGroups.forEach(function (g) { try { g.stop(); } catch (e) {} });
      }
      inst.importRoot = new BAB.TransformNode('importRoot', inst.scene);
      container.meshes.forEach(function (m) { if (!m.parent) m.parent = inst.importRoot; });
      if (container.transformNodes) container.transformNodes.forEach(function (n) { if (!n.parent) n.parent = inst.importRoot; });
      inst.importRoot.parent = inst.spin;
      inst.importRoot.position.set(0, 0, 0);
      inst.importRoot.rotation.set(0, 0, 0);
      inst.importRoot.scaling.set(1, 1, 1);

      if (container.textures) {
        container.textures.forEach(function (t) {
          if (!t) return;
          try { t.anisotropicFilteringLevel = 16; } catch (e) {}
          if (typeof t.updateSamplingMode === 'function') {
            try { t.updateSamplingMode(BAB.Texture.TRILINEAR_SAMPLINGMODE); } catch (e) {}
          }
        });
      }

      frame(inst, inst.importRoot);

      if (inst.spinObserver) inst.scene.onBeforeRenderObservable.remove(inst.spinObserver);

      var schemaStart = parseFloat(viewer.getAttribute('data-cerus-3d-start'));
      var startAngle = BAB.Tools.ToRadians(isFinite(schemaStart) ? schemaStart : 60);
      if (window.console && console.log) {
        console.log('[Cerus3D] handle="' + viewer.getAttribute('data-cerus-handle-debug') + '" rotation=' + schemaStart + ' zoom=' + viewer.getAttribute('data-cerus-3d-zoom') + ' target=' + viewer.getAttribute('data-cerus-3d-target'));
      }
      var spinDuration = 9000;
      var pause = 1200;
      var initialDelay = 1500;
      var cycle = spinDuration + pause;
      var start = performance.now() + initialDelay;
      inst.spin.rotation.set(0, startAngle, 0);
      inst.spinObserver = inst.scene.onBeforeRenderObservable.add(function () {
        var elapsed = performance.now() - start;
        if (elapsed < 0) { inst.spin.rotation.y = startAngle; return; }
        var t = elapsed % cycle;
        if (t <= spinDuration) {
          var p = t / spinDuration;
          var eased = p * p * (3 - 2 * p);
          inst.spin.rotation.y = startAngle + eased * Math.PI * 2;
        } else {
          inst.spin.rotation.y = startAngle;
        }
      });

      if (loader) loader.style.display = 'none';
      inst.sizeEngine();
    }, null, function () {
      if (loader) { loader.style.display = 'flex'; loader.innerHTML = '<span>Model failed to load</span>'; }
      if (hint) hint.style.display = 'none';
    });
  }

  function parseMap(viewer) {
    var raw = viewer.getAttribute('data-glb-map');
    if (!raw) return {};
    try { return JSON.parse(raw); } catch (e) { return {}; }
  }

  function urlForVariant(viewer, variantId) {
    var map = parseMap(viewer);
    if (variantId && map[String(variantId)]) return map[String(variantId)];
    return viewer.dataset.modelUrl || '';
  }

  var cerusModelViewer = {
    open: function (viewer, url) {
      if (!viewer) return;
      function go() {
        var inst = instances.get(viewer);
        if (!inst) {
          inst = buildInstance(viewer);
          instances.set(viewer, inst);
        }
        var finalUrl = url;
        if (!finalUrl) {
          var vid = viewer.getAttribute('data-variant-id');
          finalUrl = urlForVariant(viewer, vid);
        }
        loadGLB(viewer, inst, finalUrl);
      }
      waitForBabylon(go);
    },
    setVariant: function (viewer, variantId) {
      if (!viewer) return;
      viewer.setAttribute('data-variant-id', variantId);
      var url = urlForVariant(viewer, variantId);
      this.open(viewer, url);
    }
  };

  window.cerusModelViewer = cerusModelViewer;
  while (initQueue.length) {
    var q = initQueue.shift();
    cerusModelViewer.open(q.viewer, q.url);
  }
})();
